export const common = {
    getSocketEndpoint(){
        // var socketEndpoint = 'https://api.vuecollection.com';
        var socketEndpoint = 'https://backendapi.vuecollection.com';
        if (process.env.NODE_ENV == "development")
            socketEndpoint = 'https://backendapi.vuecollection.com/';
        return socketEndpoint;
    },
    getResortSize(_key) {
        const resortSizeList = {
            0:'Small & intimate (Less than 50 room)', 
            1:'Moderate (More than 50 rooms)',
            2:'Extensive (More than 100 rooms)'
        }
        return resortSizeList[_key];
    },
    
    getResortStyleList() {
        const resortStyleList = [
            'Modern',
            'Barefoot luxury',
            'Rustic chic',
            'Ultra-luxury',
            'Elegant',
            'Maldivian & Modern',
            'Maldivian rustic',
        ]
        return resortStyleList;
    },
    
    getResortBestForList() {
        const resortList = [
            'Romance',
            'Family',
            'Friends getaway',
            'Solo traveler',
            'Foodies',
            'Spa & wellness',
            'Wellness retreat',
            'All-inclusive',
            'Best for diving',
            'Great house reef',
            'Snorkeling',
            'Quick airport transfer',
            'Underwater dining',
            'Overwater villas only',
            'Adults-only resort',
            'Best for surfing',
            'Remote and secluded', 
        ]
        return resortList;
    },

    getResortStyle(_key) {
        const resortStyleList = {
            0:'Modern',
            1:'Barefoot luxury',
            2:'Rustic chic',
            3:'Ultra-luxury',
            4:'Elegant',
            5:'Maldivian & Modern',
            6:'Maldivian rustic',
        }
        return resortStyleList[_key];
    },
    
    getResortBestFor(_key) {
        const resortList = {
            0:'Romance',
            1:'Family',
            2:'Friends getaway',
            3:'Solo traveler',
            4:'Foodies',
            5:'Spa & wellness',
            6:'Wellness retreat',
            7:'All-inclusive',
            8:'Best for diving',
            9:'Great house reef',
            10:'Snorkeling',
            11:'Quick airport transfer',
            12:'Underwater dining',
            13:'Overwater villas only',
            14:'Adults-only resort',
            15:'Best for surfing',
            16:'Remote and secluded', 
        }
        return resortList[_key];
    },
    
    getCountryList() {
        const countryList = [
            "United States of America",
            "Aaland Islands",
            "Afghanistan",
            "Algeria",
            "American Samoa",
            "Andorra",
            "Angola",
            "Anguilla",
            "Antarctica",
            "Antigua And Barbuda",
            "Argentina",
            "Armenia",
            "Aruba",
            "Australia",
            "Austria",
            "Azerbaijan",
            "Bahamas",
            "Bahrain",
            "Bangladesh",
            "Barbados",
            "Belarus",
            "Belgium",
            "Belize",
            "Benin",
            "Bermuda",
            "Bhutan",
            "Bolivia",
            "Bonaire, Saint Eustatius and Saba",
            "Bosnia and Herzegovina",
            "Botswana",
            "Bouvet Island",
            "Brazil",
            "British Indian Ocean Territory",
            "Brunei Darussalam",
            "Bulgaria",
            "Burkina Faso",
            "Burundi",
            "Cambodia",
            "Cameroon",
            "Canada",
            "Cape Verde",
            "Cayman Islands",
            "Central African Republic",
            "Chad",
            "Chile",
            "China",
            "Christmas Island",
            "Cocos (Keeling) Islands",
            "Colombia",
            "Comoros",
            "Congo",
            "Cook Islands",
            "Costa Rica",
            "Cote D'Ivoire",
            "Croatia",
            "Cuba",
            "Curacao",
            "Cyprus",
            "Czech Republic",
            "Democratic Republic of the Congo",
            "Denmark",
            "Djibouti",
            "Dominica",
            "Dominican Republic",
            "Ecuador",
            "Egypt",
            "El Salvador",
            "Equatorial Guinea",
            "Eritrea",
            "Estonia",
            "Ethiopia",
            "Falkland Islands",
            "Faroe Islands",
            "Fiji",
            "Finland",
            "France",
            "French Guiana",
            "French Polynesia",
            "French Southern Territories",
            "Gabon",
            "Gambia",
            "Georgia",
            "Germany",
            "Ghana",
            "Gibraltar",
            "Greece",
            "Greenland",
            "Grenada",
            "Guadeloupe",
            "Guam",
            "Guatemala",
            "Guernsey",
            "Guinea",
            "Guinea-Bissau",
            "Guyana",
            "Haiti",
            "Heard and Mc Donald Islands",
            "Honduras",
            "Hong Kong",
            "Hungary",
            "Iceland",
            "India",
            "Indonesia",
            "Iran",
            "Iraq",
            "Ireland",
            "Isle of Man",
            "Israel",
            "Italy",
            "Jamaica",
            "Japan",
            "Jersey  (Channel Islands)",
            "Jordan",
            "Kazakhstan",
            "Kenya",
            "Kiribati",
            "Kuwait",
            "Kyrgyzstan",
            "Lao People's Democratic Republic",
            "Latvia",
            "Lebanon",
            "Lesotho",
            "Liberia",
            "Libya",
            "Liechtenstein",
            "Lithuania",
            "Luxembourg",
            "Macau",
            "Macedonia",
            "Madagascar",
            "Malawi",
            "Malaysia",
            "Maldives",
            "Mali",
            "Malta",
            "Marshall Islands",
            "Martinique",
            "Mauritania",
            "Mauritius",
            "Mayotte",
            "Mexico",
            "Micronesia, Federated States of",
            "Moldova, Republic of",
            "Monaco",
            "Mongolia",
            "Montenegro",
            "Montserrat",
            "Morocco",
            "Mozambique",
            "Myanmar",
            "Namibia",
            "Nauru",
            "Nepal",
            "Netherlands",
            "Netherlands Antilles",
            "New Caledonia",
            "New Zealand",
            "Nicaragua",
            "Niger",
            "Nigeria",
            "Niue",
            "Norfolk Island",
            "North Korea",
            "Northern Mariana Islands",
            "Norway",
            "Oman",
            "Pakistan",
            "Palau",
            "Palestine",
            "Panama",
            "Papua New Guinea",
            "Paraguay",
            "Peru",
            "Philippines",
            "Pitcairn",
            "Poland",
            "Portugal",
            "Puerto Rico",
            "Qatar",
            "Republic of Kosovo",
            "Reunion",
            "Romania",
            "Russia",
            "Rwanda",
            "Saint Kitts and Nevis",
            "Saint Lucia",
            "Saint Martin",
            "Saint Vincent and the Grenadines",
            "Samoa (Independent)",
            "San Marino",
            "Sao Tome and Principe",
            "Saudi Arabia",
            "Senegal",
            "Serbia",
            "Seychelles",
            "Sierra Leone",
            "Singapore",
            "Sint Maarten",
            "Slovakia",
            "Slovenia",
            "Solomon Islands",
            "Somalia",
            "South Africa",
            "South Georgia and the South Sandwich Islands",
            "South Korea",
            "South Sudan",
            "Spain",
            "Sri Lanka",
            "St. Helena",
            "St. Pierre and Miquelon",
            "Sudan",
            "Suriname",
            "Svalbard and Jan Mayen Islands",
            "Swaziland",
            "Sweden",
            "Switzerland",
            "Syria",
            "Taiwan",
            "Tajikistan",
            "Tanzania",
            "Thailand",
            "Timor-Leste",
            "Togo",
            "Tokelau",
            "Tonga",
            "Trinidad and Tobago",
            "Tunisia",
            "Turkey",
            "Turkmenistan",
            "Turks &amp; Caicos Islands",
            "Turks and Caicos Islands",
            "Tuvalu",
            "Uganda",
            "Ukraine",
            "United Arab Emirates",
            "United Kingdom",
            "Uruguay",
            "USA Minor Outlying Islands",
            "Uzbekistan",
            "Vanuatu",
            "Vatican City State (Holy See)",
            "Venezuela",
            "Vietnam",
            "Virgin Islands (British)",
            "Virgin Islands (U.S.)",
            "Wallis and Futuna Islands",
            "Western Sahara",
            "Yemen",
            "Zambia",
            "Zimbabwe",

        ]
        return countryList;
    },
}